// extracted by mini-css-extract-plugin
module.exports = {"WelcomeItems":"Welcome_WelcomeItems__2FZ3k"};